import { useContext } from 'react';

import UserPermissionsContext from '../UserPermissionsContext';

const useSelectedCategory = ({ id }) => {
  const { currentCategory, onChangeCategory } = useContext(
    UserPermissionsContext
  );

  const selected = currentCategory === id;

  const handleChangeCategory = (e) => {
    onChangeCategory(e, id);
  };

  return { selected, onChangeCategory: handleChangeCategory };
};

export default useSelectedCategory;
